import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';
import { ConnectApiClient, Product } from 'hydra-data-types';
import { Environment } from '../helpers/Environment';
import { functionsModule } from '../helpers/firebase/FirebaseFunctions';

// Use locally running emulator as Firebase Functions host. The emulator can be started by running 'yarn serve' in
// /functions
const USE_LOCAL_FUNCTIONS = process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true';

export class ApiClient extends ConnectApiClient<
  firebase.functions.HttpsCallableOptions,
  firebase.functions.HttpsCallableResult
> {
  constructor(product: Product = Product.Connect) {
    super({
      functions: functionsModule(),
      baseData: {
        product,
        clientVersion: Environment.VERSION,
      },
      options: {
        useEmulator: USE_LOCAL_FUNCTIONS,
      },
    });
  }
}
